module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAA5SURBVHjaYvz//z8DiQCmgRGbJBMDlcHgN5CFimb9p7uX/yPF6DCKFCZyvTa0vTzCDAQAAAD//wMAYRMJGOsYDeAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_03.png
// module id = 8kib
// module chunks = 11